import * as React from 'react'
import { categoryDiscover } from '@/service/api'
import { useState, useRef, useEffect } from "react"
// import { Link } from 'gatsby'
import * as cms from './category-m.module.scss'
import Loading from '@/layouts/Loading'
import ArticleItem from './ArticleItem'
import arrowGray from '@images/ic_arrow_down.png'
import BgModul from '@modules/Category/BgModul/index'
import DefaultSort from '@modules/Category/DefaultSort/index'
import PriceSort from '@modules/Category/PriceSort'
import DiscountSort from '@modules/Category/DiscoutSort'
import CategorySort from '@modules/Category/CategorySort'
import { SORTTYPE } from '@modules/Category/DefaultSort'
import { isBrowser } from '@/lib/utils'
import { useMediaQuery } from 'react-responsive'

const size = 20;
interface iSearchQ {
  s?: string
  discountRange?: any
  discountRange1?: string
  discountRange2?: string
  priceRange?: any
  priceRange1?: string
  priceRange2?: string
  selectBrands?: string[]
}


function SearchProductItem(props: any) {
  const { key, item } = props || {}
  const getName = () => {
    const firstSection = item?.searchProduct?.product.brandCN || item?.searchProduct?.product.displayBrand || item?.searchProduct?.product.brand
    const namePart = item.searchProduct?.product?.nameCN || item.searchProduct?.product?.name || item.nameCN || item.name
    if (firstSection) {
      return `${firstSection} | ${namePart}`
    }
    return namePart
  }

  const getTags = () => {
    const { labelView, off, activityOffs } = item?.searchProduct || {}
    const { shortLabels } = labelView || {}
    let tags: any[] = []
    if (shortLabels?.length) {
      const lbs = shortLabels.map((s: any) => s.labels)?.flat()?.map((lb: any) => lb.text)
      if (lbs?.length) {
        tags = [].concat(lbs)
      }
    }
    if (activityOffs?.length) {
      tags = tags.concat(activityOffs)
    }
    // if (off) {
    //   tags.push(off)
    // }
    return tags
  }
  const tags = getTags()
  return (
    <a title={`${getName()}商品图片 ${tags?.join(', ')}`} key={key} className={cms.categoryProduct} href={`/pd/${item?.searchProduct?.product?.id}/`}>
      <div className={cms.categoryProductImg}>
        <img 
          src={item?.searchProduct?.product?.images?.[0]?.thumbnail?.url || item?.searchProduct?.product?.images?.[0]?.full?.url}
          alt={`${getName()}商品图片 ${tags?.join(', ')}`}
        />
      </div>
      <h2 className={cms.categoryProductName}>{getName()}</h2>
      <div className={cms.categoryProductOrigin}>
        {item.searchProduct.origin ? `${item.searchProduct.origin} `: ''}{item.searchProduct.merchantName}
      </div>
      <div className={cms.categoryProductPrice}>
        <span className={cms.categoryProductPriceCn}>{item.searchProduct.product.priceTagCN}</span>
        <span className={cms.categoryProductPriceEn}>{item.searchProduct.product.priceTag}</span>
      </div>
      <div className={cms.categoryProductTag}>
        {
          tags?.map((tag: string, index: number) => {
            return (
              <div key={index}>
                <span>{tag}</span>
                {(index === tags.length - 1) ? null : <span className={cms.categoryProductTagLine}></span>}
              </div>
            )
          })
        }
      </div>
    </a>
  )
}

const CategoryM = (props: any) => {
  const { suggests, products: items, keyword, total: _total, relatedArticles } = props || {}

  const [products, setProducts] = useState<null | Array<any>>(items)
  const [from, setFrom] = useState(0)
  const [showLoading, setShowLoading] = useState(false)
  const categoryListRef = useRef(null)
  const [sort, setSort] = useState('')
  const firstRender = useRef(true)
  const [searchQ, setQ] = useState<iSearchQ>({})
  const [activeIndex, steActiveIndex] = useState<any>('')
  const [isFixed, setFixed] = useState(false)
  const [FILTER, setFilter] = useState([
    { displayText: '类别筛选', text: '类别筛选', component: CategorySort },
    { displayText: '排序方式', text: '默认排序', component: DefaultSort },
    { displayText: '价格筛选', text: '价格筛选', component: PriceSort },
    { displayText: '折扣筛选', text: '折扣筛选', component: DiscountSort },
  ])
  const isPc = useMediaQuery({ query: "(min-width: 960px)" })

  const search = () => {
    closeMolul()
    const disableLoading = firstRender.current && from === 0 && items?.length
    setShowLoading(!disableLoading)
    const { discountRange1, discountRange2, priceRange1, priceRange2 } = searchQ
    let q = `f=${from * size}&t=${(from + 1) * size}&q=${encodeURIComponent(keyword)}`
    if (sort) q += `&s=${sort}`
    let _discountRange1 = Number(discountRange1) || 0;
    let _discountRange2 = Number(discountRange2) || 100;
    q += `&dr=${100 - _discountRange2}-${100 - _discountRange1}`
    if (priceRange1 && priceRange2) {
      q += `&prs=${Number(priceRange1) * 100}-${Number(priceRange2) * 100}`
    } else if (priceRange1) {
      q += `&prs=${Number(priceRange1) * 100}-`
    } else if (priceRange2) {
      q += `&prs=0-${Number(priceRange2) * 100}`
    }
    categoryDiscover(q)
      .then((res: any) => {
        const productList: any[] = res.products
          ?.filter((product: any) => product.type === 'PRODUCT') || []
        if (productList?.length) {
          if (+from) {
            setProducts(products!.concat(productList))
          } else {
            setProducts(productList)
          } 
        }
        setShowLoading(false)
      }).catch(err => {
        setShowLoading(false)
      })
  }

  useEffect(() => {
    if (isPc) return
    window.scrollTo(0, 0)
    
    function onScrollToBottom() {
      // 是否自动吸顶
      const headerHeight: number = document.querySelector('#header-m')?.clientHeight || 0
      setFixed(window.pageYOffset - headerHeight >= 0)

      // 移动端滚动自动加载
      if (categoryListRef.current && !showLoading && !showLoading) {
        const scrollTop = window.pageYOffset
        const menu: HTMLElement = categoryListRef.current
        const windowHeight = window.innerHeight
        const { height: menuHeight } = menu.getBoundingClientRect()
        if (scrollTop + windowHeight > menuHeight) {
          const _form = from + 1
          setFrom(_form)
        }
      }
    }
    window.removeEventListener('scroll', onScrollToBottom)
    window.addEventListener('scroll', onScrollToBottom)
    return () => {
      window.removeEventListener('scroll', onScrollToBottom)
    }
  }, [from])

  const chooseFilterType = (index: number) => {
    steActiveIndex(activeIndex === index ? '' : index)
  }
  const setSearchQuery = (type: keyof iSearchQ, value: any) => {
    const q = { ...searchQ }
    if (type === 's') {
      // 排序选择，修改默认值
      const textItem = SORTTYPE.find(item => item.value === value)
      if (textItem) {
        const _FILTER = [...FILTER]
        _FILTER[1].text = textItem?.label
        setFilter(_FILTER)
      }
      setSort(value)
      return
    } else if (type === 'discountRange') {
      const [range1, range2] = value
      q['discountRange1'] = range1
      q['discountRange2'] = range2
    } else if (type === 'priceRange') {
      const [range1, range2] = value
      q['priceRange1'] = range1
      q['priceRange2'] = range2
    } else if (type === 'priceRange1') {
      q['priceRange'] = [value, searchQ.priceRange2]
    } else if (type === 'priceRange2') {
      q['priceRange'] = [searchQ.priceRange1, value]
    }

    q[type] = value
    setQ(q)
  }

  useEffect(() => {
    if (isPc) return
    search()
  }, [isPc, from, sort])

  useEffect(() => {
    firstRender.current = false
  }, [])

  const closeMolul = () => {
    steActiveIndex('')
    let node: HTMLDivElement | null = document.querySelector('.App')
    node?.classList.remove('over')
  }

  const Content = FILTER[activeIndex as number]?.component
  return (
    <div ref={categoryListRef} className={`${isFixed ? `${cms.categoryM} ${cms.categoryMFixed}` : cms.categoryM}`}>
      {showLoading && <Loading />}
      {
        isPc || (isBrowser && location?.search?.indexOf('from=menu') !== -1) ? null : <h1 className={cms.categoryMName}>{keyword?.trim() || '搜索页'}</h1>
      }
      <div className={`${cms.filterContent} ${cms.toLeft}`}>
        <div className={cms.filterChoose}>
          {FILTER.map((item, index) => {
            return (
              <div
                className={cms.filterItem}
                key={`filter${index}`}
                onClick={() => chooseFilterType(index)}
              >
                <span className={cms.filterItemText}>
                  {item.text}
                </span>
                <img src={ arrowGray } alt="arrow-gray"></img>
              </div>
            )
          })}
        </div>
      </div>
      {typeof activeIndex === 'number' && (
        <BgModul closeMolul={closeMolul} activeText={FILTER[activeIndex].displayText}>
          <Content
            q={searchQ}
            setSearchQuery={setSearchQuery as any}
            searchProducts={search}
          ></Content>
        </BgModul>
      )}
      <section className={cms.categorySection}>
        {
          products?.map((item: any, idx: number) => {
            return (
              <SearchProductItem key={idx} item={item} keyword={keyword} />
            )
          })
        }
      </section>
      {
        !isPc && relatedArticles?.length ? (
            <section>
              <div className={cms.searchRelatedArticlesTitle}>相关文章</div>
              <div className={cms.searchRelatedArticles}>
                {relatedArticles.map((article: any, index: number) => {
                  return (
                    <ArticleItem article={article} index={index} />
                  )
                })}
              </div>
            </section>
          ) : null
        }
      {
        !isPc && suggests?.length ? (
          <div className={cms.searchMoreKeywords}>
            <div className={cms.searchMoreKeywordsTitle}>相关搜索</div>
            <div className={cms.searchMoreKeywordsList}>
              {suggests?.map((s: any, index: number) => {
                return (
                  <a title={s.keyword} key={index} href={`/browse/${s.pathname}`}>
                    <div>{s.keyword}</div>
                  </a>
                )
              })}
            </div>
          </div>
        ) : null
      }
    </div>
  )
}

export default CategoryM